import React from 'react';
import { DISPLAY_MODE } from '../../utils/paymentPlanDisplay';

const BANNER_CONFIG = {
    [DISPLAY_MODE.PAYMENT_PLAN_DELINQUENT]: {
        alertClass: 'alert-warning',
        icon: 'bi-exclamation-triangle',
        title: 'Plan de pagos en mora',
        message:
            'Tenés una cuota vencida del plan. Regularizá el pago antes de que venza el plazo de tolerancia para evitar que el plan caiga y vuelva la deuda original del préstamo.',
    },
    [DISPLAY_MODE.PAYMENT_PLAN_BROKEN]: {
        alertClass: 'alert-warning',
        icon: 'bi-exclamation-triangle',
        title: 'Plan de pagos caído',
        message:
            'Tu plan de pagos anterior ya no está vigente. Las cuotas regulares del préstamo vuelven a ser tu obligación principal.',
    },
    [DISPLAY_MODE.PAYMENT_PLAN_COMPLETED]: {
        alertClass: 'alert-success',
        icon: 'bi-check-circle',
        title: 'Plan de pagos completado',
        message: 'Completaste tu plan de pagos. El préstamo debería estar liquidado o en proceso de cierre.',
    },
    [DISPLAY_MODE.PAYMENT_PLAN_CANCELED]: {
        alertClass: 'alert-info',
        icon: 'bi-info-circle',
        title: 'Plan de pagos cancelado',
        message: 'Tu plan de pagos fue cancelado. Seguí con las cuotas regulares del préstamo.',
    },
};

/**
 * Contextual banner for terminal payment plan states on loan detail.
 */
function PaymentPlanBanner({ displayMode, lastPaymentPlan, statusLabel }) {
    const config = BANNER_CONFIG[displayMode];

    if (!config) {
        return null;
    }

    const title = statusLabel || lastPaymentPlan?.status_label || config.title;

    return (
        <div className={`alert ${config.alertClass} border-0 shadow-sm mb-4`} role="alert">
            <div className="d-flex align-items-start gap-2">
                <i className={`bi ${config.icon} fs-5`}></i>
                <div>
                    <div className="fw-semibold mb-1">{title}</div>
                    <div className="small mb-0">{config.message}</div>
                </div>
            </div>
        </div>
    );
}

export default PaymentPlanBanner;
